export default "__VITE_ASSET__vO8FkT42__"